import { Link } from "@tanstack/react-router";
import { HelpMenu } from "@/components/help-menu";
import { ThemeToggle } from "@/components/theme-toggle";
import { Button } from "@/components/ui/button";
import logoPng from "@/logo.png";

export function PublicHeader() {
	return (
		<header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
			<div className="flex h-14 w-full items-center justify-between px-3 sm:h-16 sm:px-4 lg:px-6">
				{/* Logo */}
				<Link
					to="/"
					className="flex items-center rounded-md focus-visible:ring-2 focus-visible:ring-ring/50"
				>
					<img src={logoPng} alt="m8tes.ai" className="h-20 w-auto shrink-0 dark:invert sm:h-20" />
				</Link>

				{/* Auth Buttons & Theme Toggle */}
				<div className="flex items-center gap-1.5 sm:gap-2">
					<div className="flex items-center gap-1 rounded-md border border-border/60 bg-muted/40 p-0.5 sm:border-0 sm:bg-transparent sm:p-0">
						<div className="opacity-80 transition-opacity hover:opacity-100">
							<ThemeToggle />
						</div>
						<Button
							variant="ghost"
							size="sm"
							className="h-8 px-2 text-muted-foreground hover:text-foreground"
							asChild
						>
							<Link to="/login">Log in</Link>
						</Button>
					</div>
					<Button
						size="sm"
						className="btn-glow-blue h-8 px-3 text-xs font-semibold shadow-sm sm:h-9 sm:px-4 sm:text-sm"
						asChild
					>
						<Link to="/signup">Get started for free</Link>
					</Button>
					<div className="opacity-80 transition-opacity hover:opacity-100">
						<HelpMenu />
					</div>
				</div>
			</div>
		</header>
	);
}
